import React, { FunctionComponent } from 'react';
import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';
import { BaseLayout } from './Component/BaseLayout/BaseLayout';
import { ShoppingPlannerContextValueProvider } from './Context/ShoppingPlannerContext';
import { useResponsive } from './Hook/UseResponsive';
import { FloorPage } from './Pages/FloorPage/FloorPage';
import { RoomPage } from './Pages/RoomPage/RoomPage';
import { ShoppingList } from './Pages/ShoppingList/ShoppingList';
import { ShoppingListMobile } from './Pages/ShoppingList/ShoppingListMobile';
import { createRoot } from 'react-dom/client';
import { urls } from './Constants/Urls';
import { InsulationPage } from './Pages/Accessories/InsultationPage/InsulationPage';
import { SkirtingPage } from './Pages/Accessories/SkirtinPage/SkirtingPage';
import { InstallationPage } from './Pages/Accessories/InstallationPage/InstallationPage';

import './ShoppingPlanner.scss';

const ShoppingPlanner: FunctionComponent = () => {
    const { isLargerThanXs } = useResponsive();

    return (
        <HashRouter>
            <ShoppingPlannerContextValueProvider>
                <Routes>
                    <Route path={urls.steps.room.pattern} element={<RoomPage />} />
                    <Route path={urls.steps.floor.pattern} element={<FloorPage />} />
                    <Route path={urls.steps.accessoriesInsulation.pattern} element={<InsulationPage />} />
                    <Route path={urls.steps.accessoriesSkirting.pattern} element={<SkirtingPage />} />
                    <Route path={urls.steps.accessoriesInstallation.pattern} element={<InstallationPage />} />
                    <Route
                        path={urls.steps.shoppingList.pattern}
                        element={
                            isLargerThanXs ? (
                                <ShoppingList />
                            ) : (
                                <BaseLayout className="shopping-planner--list-mobile">
                                    <ShoppingListMobile />
                                </BaseLayout>
                            )
                        }
                    />
                    <Route path="*" element={<Navigate to={urls.steps.room.builder()} replace />} />
                </Routes>
            </ShoppingPlannerContextValueProvider>
        </HashRouter>
    );
};

const rootElement = document.querySelector('#js-dom-shopping-planner');
if (rootElement) {
    const root = createRoot(rootElement);

    root.render(<ShoppingPlanner />);
} else {
    throw new Error('Could not find root element shopping planner!');
}
